import {useContext} from 'react'
import {createPortal} from 'react-dom'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomToast, {atomToastAutoCloseTimes, atomToastPositions} from '@s-ui/react-atom-toast'
import Context from '@s-ui/react-context'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

const BASE_CLASS = 'mt-SearchSave-notification'

export const SEARCH_SAVE_NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  WARNING: 'warning',
  SYSTEM: 'system'
}

const SearchSaveNotification = ({
  type,
  autoCloseTime = atomToastAutoCloseTimes.short,
  show,
  onClose,
  portalContainer,
  className,
  action,
  children
}) => {
  const {domain} = useContext(Context)
  const isMobile = domain.get('config').get('isMobile')

  const notification = (
    <div className={`${BASE_CLASS}Layer`}>
      <AtomToast
        autoCloseTime={autoCloseTime}
        iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
        onClose={onClose}
        position={isMobile ? atomToastPositions.bottom : atomToastPositions.topRight}
        show={show}
      >
        <div className={cx(BASE_CLASS, `${BASE_CLASS}--${type}`, className)}>
          {children}
          {action && <div className={`${BASE_CLASS}Action`}>{action}</div>}
        </div>
      </AtomToast>
    </div>
  )

  return portalContainer ? createPortal(notification, portalContainer) : notification
}

SearchSaveNotification.displayName = 'SearchSaveNotification'

SearchSaveNotification.propTypes = {
  type: PropTypes.oneOf(Object.values(SEARCH_SAVE_NOTIFICATION_TYPES)).isRequired,
  autoCloseTime: PropTypes.number,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  portalContainer: typeof Element !== 'undefined' ? PropTypes.instanceOf(Element) : PropTypes.object,
  className: PropTypes.string,
  action: PropTypes.node,
  children: PropTypes.node
}

export default SearchSaveNotification
